import { z } from 'zod';

const ApiResponseStatusSchema = z.enum(['success', 'error']);

export const BaseApiResponseSchema = z.object({
  code: z.number(),
  status: ApiResponseStatusSchema,
});
